module.exports = __webpack_public_path__ + "img/banner@2x (2).acf950b6.png";